var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-all-wrapper"},[_c('BtnBack'),_c('div',{staticClass:"pt-16"},[_c('GridRecipeViewAll',{attrs:{"recipes":_vm.recipes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }